import styled from 'styled-components';

const SummaryTabStyles = styled.div`
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
`;

export default SummaryTabStyles;

export const BusinessCardStyles = styled.div`
  .content-business-logo {
    text-align: center;
    .ant-avatar {
      max-width: 100%;
    }
  }
`;

export const CentreInformationStyles = styled.div`
  .row-centre-information {
    font-size: 16px;
  }
  .col-value {
    font-weight: 600;
    line-height: 26px;
    word-break: break-word;
  }
`;

export const VirtualTourStyles = styled.div`
  position: relative;
  padding-bottom: 55%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 8px;
    width: 100%;
    height: 100%;
  }
`;
